// src/components/Sidebar.js
import {
  ArrowRightIcon,
  ArrowLeftIcon,
  HomeIcon,
  CogIcon,
  EllipsisVerticalIcon,
  CodeBracketIcon,
  KeyIcon,
  ComputerDesktopIcon,
  EnvelopeIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import SidebarItem from './SidebarItem';

function Sidebar({ expanded, setExpanded, children }) {
  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 z-40 bg-black bg-opacity-50 transition ${
          expanded ? 'block sm:hidden' : 'hidden'
        }`}
        onClick={() => setExpanded(false)}
      />

      {/* Sidebar */}
      <aside
        className={`fixed sm:relative top-0 left-0 h-screen bg-white shadow-sm border-r transition-all duration-300 z-50 flex flex-col
          ${expanded ? 'w-5/6 sm:w-64' : 'w-0 sm:w-20'} ${
          expanded || window.innerWidth >= 640 ? 'visible' : 'invisible'
        }`}
      >
        {/* Logo + Toggle */}
        <div className="flex items-center justify-between p-4 pb-2 border-b">
          <img
            src="/images/SerchuVaLogo.png"
            alt="Logo"
            className={`transition-all ${expanded ? 'w-32' : 'w-0'}`}
          />
          <button
            onClick={() => setExpanded((prev) => !prev)}
            className="rounded-lg bg-gray-50 p-1.5 hover:bg-gray-100"
          >
            {expanded ? (
              <ArrowRightIcon className="h-6 w-6" />
            ) : (
              <ArrowLeftIcon className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Menu Items */}
        <div className="flex-1 overflow-y-auto px-3 py-4">
          <ul className="space-y-1">
            {React.Children.map(children, (child) =>
              React.cloneElement(child, {
                expanded,
                closeSidebar: () => setExpanded(false),
              })
            )}
          </ul>
        </div>
      </aside>

      {/* Mobil Açma Butonu */}
      {!expanded && (
        <button
          onClick={() => setExpanded(true)}
          className="fixed top-4 left-4 z-50 bg-white p-2 rounded-full shadow border sm:hidden"
        >
          <ArrowLeftIcon className="h-5 w-5 text-gray-600" />
        </button>
      )}
    </>
  );
}

export default function MakeSidebar() {
  const [expanded, setExpanded] = useState(window.innerWidth >= 640);
  const isAdmin = sessionStorage.getItem('isAdmin') === 'true';

  const navBarItems = [
    ...(isAdmin
      ? []
      : [
          { icon: <HomeIcon />, text: 'Dashboard', path: '/dashboard' },
        ]),
    ...(isAdmin
      ? [
          {
            icon: <CogIcon />,
            text: 'Dashboard',
            subMenu: [
              { icon: <HomeIcon />, text: 'Dashboard', path: '/dashboard' },
              {
                icon: <HomeIcon />,
                text: 'Admin Dashboard',
                path: '/admin/dashboard',
              },
            ],
          },
          { icon: <CodeBracketIcon />, text: 'Yazılım/Paket Yönetimi', path: '/admin/paket' },
          { icon: <KeyIcon />, text: 'Lisans Yönetimi', path: '/admin/lisans' },
          { icon: <ComputerDesktopIcon />, text: 'Cihaz Yönetimi', path: '/admin/cihaz' },
          { icon: <UserIcon />, text: 'Kullanıcı Yönetimi', path: '/admin/users' },
          { icon: <EnvelopeIcon />, text: 'SMTP Ayarları', path: '/admin/apiayar' },
        ]
      : []),
    { icon: <KeyIcon />, text: 'Lisanslarım', path: '/managelicense' },
    {
      icon: <CogIcon />,
      text: 'Yazılım Listesi',
      subMenu: [{ icon: <HomeIcon />, text: 'İşletmeRadar', path: '/app/isletmeradar' }],
    },
  ];

  return (
    <div className="flex">
      <Sidebar expanded={expanded} setExpanded={setExpanded}>
        {navBarItems.map((item, idx) => (
          <SidebarItem key={idx} {...item} />
        ))}
      </Sidebar>
      <div
        className={`flex-1 transition-all duration-300 ${
          expanded ? 'ml-0 sm:ml-0' : 'ml-0 sm:ml-0'
        }`}
      >
        {/* Ana içerik */}
      </div>
    </div>
  );
}
